export const POST_DOC_FOR_WORKFORCE = "post_doc_for_workforce";
export const RESET_POST_DOC_FOR_WORKFORCE = "reset_post_doc_for_workforce";
export const POST_DOC_FOR_WORKFORCE_SUCCESS = "post_doc_for_workforce_success";
export const POST_DOC_FOR_WORKFORCE_FAILURE = "post_doc_for_workforce_failure";
